'use strict';

var React = require('react'),
    Button = require('../atoms/Button'),
    Icon = require('../atoms/Icon'),
    AudioProgress = require('../atoms/AudioProgress'),
    ResponsiveImageQueueMixin = require('../mixins/ResponsiveImageQueueMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    gradient = require('../utils/gradient'),
    PlayerActionCreators = require('../actions/PlayerActionCreators'),
    { PropTypes } = React;

require('./AudioCover.less');

var AudioCover = React.createClass({
  mixins: [
    ResponsiveImageQueueMixin,
    PureRenderMixin,
    ClassNameMixin
  ],

  propTypes: {
    size: React.PropTypes.oneOf(['small', 'large']).isRequired,
    linkUrl: PropTypes.string.isRequired,
    artwork: PropTypes.object.isRequired,
    colors: PropTypes.shape({
      top: PropTypes.string.isRequired,
      bottom: PropTypes.string.isRequired
    }).isRequired,
    duration: PropTypes.number.isRequired,
    alwaysShowControls: PropTypes.bool,
    isPlaying: PropTypes.bool.isRequired,
    isPaused: PropTypes.bool.isRequired,
    onPlay: PropTypes.func.isRequired,
    onPause: PropTypes.func.isRequired,
    onForward: PropTypes.func.isRequired,
    onBackward: PropTypes.func.isRequired,
    currentTime: PropTypes.number.isRequired
  },

  getDefaultProps: function () {
    return {
      size: 'large'
    };
  },

  getCSSModifiers() {
    return {
      showControls: this.shouldShowControls(),
      showProgress: this.shouldShowProgress()
    };
  },

  getImageOptions() {
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    return {
      image: this.props.artwork,
      mode: 'scale_crop',
      sizes: {
        normal: true,
        retina: devicePixelRatio > 1.5
      }
    };
  },

  getImageSizes() {
    if (this.props.size === 'small') {
      return {
        'default': 112,
        'xs': 112,
        'sm': 112,
        'md': 112,
        'lg': 112,
        'xl': 112
      };
    } else {
      return {
        'default': 480,
        'xs': 640,
        'sm': 288,
        'md': 320,
        'lg': 320,
        'xl': 320
      };
    }
  },

  shouldShowControls() {
    return this.props.alwaysShowControls || this.props.isPlaying || this.props.isPaused;
  },

  shouldShowProgress() {
    return this.props.isPlaying || this.props.isPaused;
  },

  componentDidUpdate(prevProps) {
    if (prevProps.artwork !== this.props.artwork) {
      this.updateImageQueue();
    }
  },

  getStyle() {
    var { colors } = this.props,
        background;

    background = this.hasLoadedImage() ?
      this.getBackgroundImageUrl() :
      gradient('#' + colors.top, '#' + colors.bottom);

    return {
      backgroundImage: background
    };
  },

  render() {
    var isLarge = this.props.size === 'large',
        playIconSize = isLarge ? 'large' : 'small',
        previousNextIconSize = isLarge ? 'small' : 'xxsmall',
        playSize = isLarge ? 'xxlarge' : 'medium';


    return (
      <div className={this.getClassName()}
           style={this.getStyle()}>

        {this.renderLoaderImg()}

        <div className='AudioCover-box'>
          <div className='AudioCover-logo'>
            <a target='_blank'
               href={this.props.linkUrl}>
              <img className='AudioCover-logoImg'
                   src='//stampsy-eu-1.s3.amazonaws.com/2014/10/31/media/soundcloud-logo--light.svg' />
            </a>
          </div>

          <div className='AudioCover-backward'>
            <Icon name='backward'
                  size={previousNextIconSize}
                  mode='stroke'
                  onClick={this.handleBackwardClick}/>
          </div>

          {this.props.isPlaying &&
            <Button size={playSize}
                    context='AudioCover'
                    color='black'
                    overlay
                    round
                    className='AudioCover-pause'
                    onClick={this.props.onPause}>
              <Icon name='pause'
                    size={playIconSize}
                    mode='stroke' />
            </Button>
          }

          {!this.props.isPlaying &&
            <Button size={playSize}
                    context='AudioCover'
                    color='black'
                    overlay
                    round
                    className='AudioCover-play'
                    onClick={this.props.onPlay}>
              <Icon name='play'
                    size={playIconSize}
                    mode='stroke' />
            </Button>
          }

          <div className='AudioCover-forward'>
            <Icon name='forward'
                  size={previousNextIconSize}
                  mode='stroke'
                  onClick={this.handleForwardClick} />
          </div>

          <div className='AudioCover-progress'>
            <AudioProgress currentTime={this.props.currentTime}
                           trackDuration={this.props.duration}
                           onChangeTime={this.handleProgressChangeTime}
                           context={this.props.context} />
          </div>
        </div>
        {this.props.children}
      </div>
    );
  },

  handleProgressChangeTime(time) {
    PlayerActionCreators.setCurrentTime(this.props.uuid, time);
  },

  handleBackwardClick() {
    this.props.onBackward();
  },

  handleForwardClick() {
    this.setState({
      currentTime: 0
    });

    this.props.onForward();
  }
});

module.exports = AudioCover;



/** WEBPACK FOOTER **
 ** ./molecules/AudioCover.jsx
 **/